var decreaseValue = function decreaseValue(value, increment, minimum) {
  return value - increment < minimum ? minimum : value - increment;
};
var increaseValue = function increaseValue(value, increment, maximum) {
  return value + increment > maximum ? maximum : value + increment;
};
var formatNumber = function formatNumber(number, lang) {
  return number.toLocaleString(lang);
};

export { decreaseValue, formatNumber, increaseValue };
